export default {
  'apiCallResponseStatusCodeActionMapping.title': 'Mapeos Código Respuesta / Acción Siguiente',

  'apiCallResponseStatusCodeActionMapping.form.responseHttpStatusCode': 'Código Http',
  'apiCallResponseStatusCodeActionMapping.form.nextAction': 'Acción Siguiente',
};
